export default __webpack_public_path__ + "static/media/bored-babe-gif3.f91e8156.gif";